/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MetricsTotalOfflineNodesCountRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsTotalOfflineNodesCountRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalOfflineNodesCountRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsTotalOfflineNodesCountRequest$Outbound = {
  end: number | null;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsTotalOfflineNodesCountRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalOfflineNodesCountRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsTotalOfflineNodesCountRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTotalOfflineNodesCountRequest$ {
  /** @deprecated use `GetApiV3MetricsTotalOfflineNodesCountRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTotalOfflineNodesCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalOfflineNodesCountRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTotalOfflineNodesCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalOfflineNodesCountRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsTotalOfflineNodesCountRequest$Outbound;
}

export function getApiV3MetricsTotalOfflineNodesCountRequestToJSON(
  getApiV3MetricsTotalOfflineNodesCountRequest:
    GetApiV3MetricsTotalOfflineNodesCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsTotalOfflineNodesCountRequest$outboundSchema.parse(
      getApiV3MetricsTotalOfflineNodesCountRequest,
    ),
  );
}

export function getApiV3MetricsTotalOfflineNodesCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsTotalOfflineNodesCountRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsTotalOfflineNodesCountRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsTotalOfflineNodesCountRequest' from JSON`,
  );
}
